import React from 'react';
import {Box} from '@mui/material';
import {Body, designSystemToken} from '@lightricks/react-design-system';

interface CampaignCreatorInfoRowProps {
  label: string;
  value: string;
  isLast?: boolean;
  hasBorder?: boolean;
}

function CampaignCreatorInfoRow({
  label,
  value,
  isLast = false,
  hasBorder = true,
}: CampaignCreatorInfoRowProps) {
  const shouldShowBorder = hasBorder && !isLast;

  return (
    <Box
      sx={{
        'display': 'flex',
        'borderBottom': shouldShowBorder
          ? `1px solid ${designSystemToken('semantic.border.secondary')}`
          : 'none',
        '&:last-child': {
          borderBottom: 'none',
        },
      }}
    >
      <Box
        sx={{
          flex: '0 0 120px',
          padding: 2,
          borderRight: `1px solid ${designSystemToken('semantic.border.secondary')}`,
          backgroundColor: designSystemToken('semantic.bg.secondary'),
        }}
      >
        <Body
          size="sm"
          color={designSystemToken('semantic.fg.secondary')}
          sx={{textTransform: 'uppercase', fontWeight: 'medium'}}
        >
          {label}
        </Body>
      </Box>
      <Box sx={{flex: 1, padding: 2}}>
        <Body size="md" color={designSystemToken('semantic.fg.primary')}>
          {value}
        </Body>
      </Box>
    </Box>
  );
}

export default CampaignCreatorInfoRow;
